var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "BARLogoSVG",
    width: 44,
    height: 44,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "barLogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "barCircle",
    fill: "#9c0",
    fillRule: "evenodd",
    stroke: "#969696",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    d: "M1 22a21 21 0 1 1 42 0 21 21 0 0 1-42 0z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "barText",
    x: 4.8,
    y: 27.7,
    fill: "#fff",
    strokeWidth: 0.3,
    fontFamily: "Arial, Arial_MSFontService, sans-serif",
    fontSize: 15.9,
    fontWeight: 700
  }, "\n      BAR\n    "))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarLogo);
export default __webpack_public_path__ + "static/media/BAR-logo.8729e10666334448385f2329cf2713fd.svg";
export { ForwardRef as ReactComponent };